import { ViewType } from '@this+that/models';

import type { UserCommunicationsState } from './types';
import { LABEL_PREFIXES } from '../../../components/InboxLabelsTabsFilter/constants';

type ArrayStateKey = keyof Omit<
  UserCommunicationsState,
  | 'labels'
  | 'unconfirmedDrafts'
  | 'deletedDrafts'
  | 'lastDeletedDraftSliceKeys'
  | 'recentlyInsertedIds'
  | 'syncedViewTypes'
  | 'fetchGeneration'
  | 'isLoading'
  | 'createLoading'
  | 'forwardLoading'
  | 'replyLoading'
  | 'deleteLoading'
  | 'archiveLoading'
  | 'moveToInboxLoading'
  | 'markAsReadLoading'
  | 'markAsUnreadLoading'
  | 'startKeys'
>;

/**
 * Maps a ViewType to its corresponding state key.
 * Handles the special case where ALL_EMAILS maps to 'all', not 'all_emails'.
 *
 * @param viewType - The ViewType to map
 * @returns The corresponding state key
 */
export const viewTypeToStateKey = (
  viewType: Exclude<ViewType, `Label_${string}`>,
): ArrayStateKey => {
  const map: Record<Exclude<ViewType, `Label_${string}`>, ArrayStateKey> = {
    PRIMARY: 'primary',
    PROMOTIONS: 'promotions',
    SOCIAL: 'social',
    UPDATES: 'updates',
    FORUMS: 'forums',
    DRAFT: 'draft',
    SENT: 'sent',
    SPAM: 'spam',
    TRASH: 'trash',
    ALL_EMAILS: 'all', // ← Critical: ALL_EMAILS maps to 'all', not 'all_emails'
  };

  return map[viewType];
};

export const labelStateKey = (viewType: ViewType): string =>
  viewType.replace(LABEL_PREFIXES.GMAIL_LABEL, '');
